export default "/_next/static/audios/8e6b487513235f1c031404c9e74b51c6.mp3";